module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/iterators.js
// module id = 183
// module chunks = 1